// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__T1ScR","choiceBoxes":"toolbarselects_choiceBoxes__1AjUq","simpleField":"toolbarselects_simpleField__1otkh"};